import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "FloodgateFeedback" */ "./lazyIndex"), { name: "FloodgateFeedback" });

export const lazyLoadAndInitializeFloodgateEngine: LazyAction<typeof lazyIndex.loadAndInitializeFloodgateEngine, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadAndInitializeFloodgateEngine);
export const lazyLogFloodgateActivity: LazyImport<typeof lazyIndex.logFloodgateActivity, typeof lazyModule> = new LazyImport(lazyModule, m => m.logFloodgateActivity);

export type { SurveyActivityType } from "./schema/SurveyActivityType";
